// libs
import styled from "@emotion/styled";

// mixins
import { getColumnDimension } from "shared/components/AdPlatformWidgets/Desktop/mixin";

export const TextLink = styled.a<{ numOfColumns: number; align: string }>`
    height: 40px;
    display: inline-block;
    font-size: 1.0714rem;
    text-transform: capitalize;
    padding: 12px;
    text-decoration: none;
    border: 1px solid #ebebeb;
    border-radius: 4px;
    margin: 0 10px 10px 0;

    ${({ numOfColumns }) => getColumnDimension(numOfColumns)}

    ${props => `text-align: ${props.align}`}
`;
